import React from 'react';
import { getTickets } from '../../../../../helpers/ticket-helper';

const EMPTY_DASHBOARD_STATS = {
    total: 0,
    incoming: 0,
    inProgress: 0,
    pending: 0,
    resolved: 0,
    overdue: 0,
};

export const useTaskListDashboardStats = ({ token }) => {
    const [dashboardStats, setDashboardStats] = React.useState(EMPTY_DASHBOARD_STATS);

    const buildDashboardStats = React.useCallback((rows, totalCount) => {
        const now = Date.now();
        const safeRows = Array.isArray(rows) ? rows : [];

        const incoming = safeRows.filter((ticket) => String(ticket?.status || '') === 'NEW').length;
        const inProgress = safeRows.filter((ticket) => String(ticket?.status || '') === 'IN_PROGRESS').length;
        const pending = safeRows.filter((ticket) => {
            const status = String(ticket?.status || '');
            return status === 'PENDING_CUSTOMER' || status === 'PENDING_THIRD_PARTY';
        }).length;
        const resolved = safeRows.filter((ticket) => {
            const status = String(ticket?.status || '');
            return status === 'RESOLVED' || status === 'CLOSED';
        }).length;
        const overdue = safeRows.filter((ticket) => {
            const status = String(ticket?.status || '');
            if (status === 'RESOLVED' || status === 'CLOSED' || status === 'CANCELLED') {
                return false;
            }

            const dueDate = ticket?.resolutionDueDate || ticket?.firstResponseDueDate;
            if (!dueDate) {
                return false;
            }

            const parsed = new Date(dueDate).getTime();
            return Number.isFinite(parsed) && parsed < now;
        }).length;

        return {
            total: Number(totalCount || 0),
            incoming,
            inProgress,
            pending,
            resolved,
            overdue,
        };
    }, []);

    const loadDashboardStats = React.useCallback(async () => {
        if (!token) {
            setDashboardStats(EMPTY_DASHBOARD_STATS);
            return;
        }

        const initialResp = await getTickets(token, { limit: 1, offset: 0 });
        if (!initialResp?.success) {
            return;
        }

        const total = Number(initialResp.total || 0);
        if (total === 0) {
            setDashboardStats(EMPTY_DASHBOARD_STATS);
            return;
        }

        const fullResp = await getTickets(token, { limit: total, offset: 0 });
        if (!fullResp?.success) {
            return;
        }

        setDashboardStats(buildDashboardStats(fullResp.data, total));
    }, [token, buildDashboardStats]);

    return {
        dashboardStats,
        loadDashboardStats,
    };
};